import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(<path d="M19 13H5v-2h14v2z" />);
